/** Genera id DOM univoci per label, hint ed errori (aria-describedby). */
let ariaFieldIdCounter = 0;

export function createAriaFieldId(prefix: string): string {
  ariaFieldIdCounter += 1;
  return `${prefix}-${ariaFieldIdCounter}`;
}
